module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_3.f519b22a.png";